import get from 'lodash/get';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_FETCH_DOMAINS,
} from '../../../actions/actionTypes';

const domains = fetchReducerGenerator(
  [SHORTENER_RESOLUTION_CLEAR],
  SHORTENER_RESOLUTION_FETCH_DOMAINS
);

export default domains;

const descendingSort = (domainA, domainB) => domainA.counter < domainB.counter;

export const getShortenerResolutionDomains = state => {
  const domains = get(state, 'response.data', []) || [];
  const domainsWithDescriptions = domains.map(domain => {
    domain.description = `${domain.url} (${domain.counter})`;
    return domain;
  });
  return domainsWithDescriptions.sort(descendingSort);
};
